var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{on:{"click":_vm.updateSource}},[_vm._v(" "+_vm._s(_vm.$t('TABLES.PROJECT_USER_NAVS.CHANGE_SOURCE'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }